import { map } from 'rxjs';

const _void = () => undefined;

export const VOID = map(_void);

export const toVoid = () => map(() => undefined);
